import { Navigate } from 'react-router'
import { useAuth } from '@/features/auth'
import { useLangParam } from '@/shared/hooks'
import { LandingPage } from './landing-page'

/**
 * Root Page - Conditional routing based on auth state
 * Shows LandingPage for non-authenticated users
 * Redirects to Dashboard for authenticated users
 *
 * Note: Language is already handled by LanguageLayout (parent).
 * This component only needs to use the current lang for navigation.
 */
export function RootPage() {
  const { user, isLoading } = useAuth()
  const { lang } = useLangParam()

  // Show loading state while checking auth
  if (isLoading) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <div className="h-8 w-8 animate-spin rounded-full border-4 border-accent border-t-transparent" />
      </div>
    )
  }

  // Redirect authenticated users to localized dashboard
  if (user) {
    return <Navigate to={`/${lang}/dashboard`} replace />
  }

  // Show landing page for non-authenticated users
  return <LandingPage />
}
